// packages/supabase-client/src/index.ts
// this supabase client is for frontend usage as it uses anon keys. Backend won't use this because it needs stronger security measures
import { createClient } from "@supabase/supabase-js";
/**
 * Creates a configured Supabase client instance
 * @param url - Supabase project URL
 * @param anonKey - Supabase anonymous key
 * @returns Configured Supabase client
 */
export function createSupabaseClient(url, anonKey) {
    return createClient(url, anonKey, {
        auth: {
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: true,
        },
    });
}
// Singleton instance - initially null, must be initialized
let supabaseInstance = null;
/**
 * Initialize the global Supabase client instance
 * Call this once at app startup with your environment-specific config
 */
export function initializeSupabase(url, anonKey) {
    supabaseInstance = createSupabaseClient(url, anonKey);
    return supabaseInstance;
}
/**
 * Get the initialized Supabase client instance
 * @throws Error if client hasn't been initialized
 */
export function getSupabaseClient() {
    if (!supabaseInstance) {
        throw new Error("Supabase client not initialized. Call initializeSupabase() first.");
    }
    return supabaseInstance;
}
